import React, { useContext, useState } from 'react'
import { pRecordTime } from '../utils/parameters';

const VideoContext = React.createContext();

export function useVideo() {
    return useContext(VideoContext)
}

export function VideoProvider({ children }) {
    /* Camera permissions */
    const [cameraPermissions, setCameraPermissions] = useState({ perm: true, cam: false })
    /* Recording timeout */
    const [recTime, setRecTime] = useState(pRecordTime.default)
    /* Status
    * 0: Waiting for 'Grabar' button
    * 1: Run BlazeFace (just one time)
    * 2: Face detected
    * 3: Countdown: 3,2,1 & Start recording 
    * 4: Start Recording
    * 5: Stop recording and Repetion mode enabled
    * 14: Error
    */
    const [faceStatus, setFaceStatus] = useState(0)

    /* Exported values */
    const value = {
        recTime, setRecTime, faceStatus, setFaceStatus, cameraPermissions, setCameraPermissions
    }

    return (
        <VideoContext.Provider value={value}>
            {children}
        </VideoContext.Provider>
    )
}